export default __webpack_public_path__ + "static/media/slider2.fb04be93.jpg";